import React from 'react';
import DealSection from '../../../DealSection';

function MoreOffers({
    similarOffers,
    sameBrandOffers,
    topOffers,
    isRewards,
    isBundleDeal
}) {
    return (
        <>
            {similarOffers?.length > 0 && (
                <DealSection
                    type={
                        isBundleDeal
                            ? 'OTHER DEALS IN THIS BUNDLE'
                            : isRewards
                            ? 'SIMILAR REWARDS'
                            : 'SIMILAR OFFERS'
                    }
                    offers={similarOffers?.slice(0, 4)}
                    isRewards={isRewards}
                />
            )}
            {sameBrandOffers.length > 0 && !isRewards && (
                <DealSection
                    type="OTHER OFFERS FROM THIS BRAND"
                    offers={sameBrandOffers.slice(0, 4)}
                    className={similarOffers.length > 0 ? 'mt-16' : ''}
                />
            )}
            {topOffers.length > 0 && !isRewards && (
                <DealSection
                    type="OFFERS OF THE MONTH"
                    offers={topOffers.slice(0, 4)}
                    className={
                        similarOffers.length > 0 || sameBrandOffers.length > 0
                            ? 'mt-16'
                            : ''
                    }
                />
            )}
        </>
    );
}

export default MoreOffers;
